import Container from 'components/UI/Container';
import React, { useEffect } from 'react';
import './PageHeader.module.scss';
import indexPage from 'actions/page/index';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

export default function PageHeader({ image, name, description }) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexPage());
    }, []);

    const { pathname } = useLocation();
    const routeSlug = pathname.split('/')[1];

    const page = useSelector((state) => {
        const pages = state.page.entities.allIds.map(
            (pageId) => state.page.entities.byId[pageId]
        );
        return pages.find((p) => p.slug === routeSlug);
    });

    const imageData = page?.image || image;
    const nameData = page?.name || name;
    const descriptionData = page?.description || description;

    return (
        <>
            <Container image={imageData}>
                <div styleName="page-header ">
                    <h1>{nameData}</h1>
                    <p>{descriptionData}</p>
                </div>
            </Container>
        </>
    );
}
